
































































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { Action } from 'vuex-class';

const namespace: string = 'auth';

@Component
export default class ModalLogin extends Vue {
  @Prop({ type: Boolean }) isModalLogin!: boolean;
  @Action('login', { namespace }) c_login!: any;

  public dialogVisible: boolean = this.isModalLogin;
  public isLoading: boolean = false;

  public ruleForm: any = {
    email: '',
    password: '',
    expiresIn: false,
  };
  public rules = {
    email: [
      {
        type: 'email',
        required: true,
        trigger: ['blur', 'change'],
        message: '이메일 형식이 아닙니다.',
      },
    ],
    password: [
      { type: 'string', required: true, message: '비밀번호를 입력해주세요.' },
      { min: 6, max: 30, message: '6자 이상 입력해주세요.', trigger: 'blur' },
    ],
  };

  get isNotEmpty() {
    let type: string = 'info';
    if (this.ruleForm.email !== '' || this.ruleForm.password !== '') type = 'primary';
    return type;
  }

  @Emit('emitModalLoginClose')
  handleClose() {
    this.dialogVisible = false;
  }

  submitForm(formName: string) {
    (this.$refs[formName] as any).validate(async (valid: boolean) => {
      if (valid) {
        try {
          this.isLoading = true;
          await this.c_login(this.ruleForm);
          this.isLoading = false;
          this.dialogVisible = false;
        } catch (e) {
          this.isLoading = false;
          console.log(e);
          this.$message.error(e.response.data.error.message);
        }
      } else {
        this.$message.error('유효하지 않은 형식의 데이터가 있습니다.');
        return false;
      }
    });
  }
}
